export enum DisplayAnalysisType {
  Linear = `linear`,
  Logarithmic = `logarithmic`,
}

export enum DisplayPlotStyle {
  Stacked = `stacked`,
  Standard = `standard`,
}

export enum LineStyle {
  Standard = `Solid`,
  Comparison = `ShortDot`,
  Incomplete = `Dot`,
}

export enum XAxisUnit {
  Number = `number`,
  Time = `time`,
}
